module.exports = __webpack_public_path__ + "media/assets/icons/address-c52763f7bee5bbdbac8d4fe1414e1f7f.svg";